import { pushToMatomoIfPossible } from "@utdanningsdirektoratet/utils/analytics";
import { useLocation } from 'react-router-dom';
import { useDeepCompareEffect } from "../useDeepCompare";

export interface Dimension {
  id: number,
  value: string | undefined
}

export const userRoleDimension = (userRoleName: string): Dimension => ({ id: 1, value: userRoleName });
export const pageAccessDimension = (pageAccessName: string | undefined): Dimension => ({ id: 2, value: pageAccessName });

/*
Logs pageview events to Matomo Analytics on router location changes.
@param dimensions A list of custom dimensions to add to Matomo log events. If one of these has an undefined value, no event is fired
*/
export const usePageViewTracking = (dimensions: Array<Dimension> = []) => {
  const location = useLocation();

  useDeepCompareEffect(() => {
    if (dimensions.some((dimension) => dimension.value === undefined)) {
      return
    }

    dimensions.forEach((dimension) => {
      if (dimension.value !== undefined) {
        pushToMatomoIfPossible(["setCustomDimension", dimension.id, dimension.value]);
      }
    });

    pushToMatomoIfPossible(['setCustomUrl', location.pathname]);
    pushToMatomoIfPossible(['trackPageView']);
  }, [location.pathname, dimensions]);
};
